import classNames from 'clsx';
import React, { memo, useEffect } from 'react';
import { sendGaUploader } from 'reactApp/modules/uploadList/uploadList.helpers';
import { EFileError, IInputFile } from 'reactApp/modules/uploadList/uploadList.model';
import { InfoErrorComponent } from 'reactApp/ui/UploadList/Problems/InfoError';

import styles from './Problems.css';

interface IProps {
    file: IInputFile;
    show: boolean;
    isDark?: boolean;
}

export const Problem = memo(({ file, show, isDark = false }: IProps) => {
    const error = file.error;

    let problem;

    useEffect(() => {
        if (!show) {
            return;
        }

        sendGaUploader('show_error', error);
    }, [show]);

    // eslint-disable-next-line sonarjs/no-all-duplicated-branches
    switch (error) {
        case EFileError.OVER_QUOTA_CLOUD_B2B:
        case EFileError.SKIPPED_FILE:
        case EFileError.FILE_EXIST:
        case EFileError.CANCELLED_FILE:
        case EFileError.IGNORED_FILE:
        case EFileError.NAME_TOO_LONG:
        case EFileError.INVALID_CHARACTERS:
        case EFileError.OVER_QUOTA_LIMIT_DOWNLOAD:
        case EFileError.CONNECTION_ERROR:
        case EFileError.READ_ONLY_DIRECTORY:
        case EFileError.LOCAL_FILE_NOT_FOUND:
        case EFileError.OVER_QUOTA_CLOUD_AT_OWNER:
        case EFileError.INVALID_CHARACTERS_AUTO_FIX:
        case EFileError.NAME_TOO_LONG_AUTO_FIX:
        case EFileError.USER_FILE_SIZE_LIMIT:
        case EFileError.USER_FILE_SIZE_LIMIT_OVER_100_GB: {
            problem = <InfoErrorComponent file={file} />;
            break;
        }
        default: {
            problem = <InfoErrorComponent file={file} />;
            break;
        }
    }

    return (
        <div
            className={classNames({
                [styles.warning]: true,
                [styles.show]: show,
                [styles.dark]: isDark,
            })}
            data-qa-warning={error}
        >
            {problem}
        </div>
    );
});

Problem.displayName = 'Problem';
